import React from "react";

const KartiniCopyright = () => {
  return (
    <div className="text-center text-xs text-monochrome-400">
      <p className="mb-2">Copyright © 2024 PT. Kartini Otomasi Indonesia</p>
    </div>
  );
};

export default KartiniCopyright;
